import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppStartedPayload, IEvent } from './types';

export interface IAppState {
  events: IEvent[];
  loading: boolean;
  filter?: string;
  categories: string[];
  filteredEvents: IEvent[];
}

export const initialState: IAppState = {
  loading: true,
  events: [],
  categories: [],
  filteredEvents: [],
};

export const statePropName = 'app';

const appSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    startApp: (state: IAppState) => {
      state.loading = true;
      state.events = [];
      state.categories = [];
      state.filteredEvents = [];
    },
    started: (state: IAppState, action: PayloadAction<IAppStartedPayload>) => {
      state.loading = false;
      state.events = action.payload.events;
      state.categories = action.payload.categories;
      state.filteredEvents = action.payload.filteredEvents;
    },
    filterChanged: (state: IAppState, action: PayloadAction<string | undefined>) => {
      state.filter = action.payload;
    },
    setCategories: (state: IAppState, action: PayloadAction<string[]>) => {
      state.categories = action.payload;
    },
    setFilteredEvents: (state: IAppState, action: PayloadAction<IEvent[]>) => {
      state.filteredEvents = action.payload;
    },
  },
});

export const AppActions = appSlice.actions;
export default appSlice.reducer;
